import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';

function NotFound() {
    const { t } = useTranslation();
    // Declare a new state variable, which we'll call "count"  const [count, setCount] = useState(0);
    const [count, setCount] = useState(0);
    return (
        <div className="container">
            <p className="lead">
                {t('notfound-message')}
            </p>
            <div>
                <button className="btn btn-outline-dark" onClick={() => setCount(count + 1)}>
                    {t('click-me')}
                </button>
            </div>
            <p className="lead text-">{t('clicked-times', { count })}</p>
            <hr />
            <div className="lead">{t('or-go-home')} <Link to="/">{t('home')}</Link></div>
        </div>
    );
}
export default NotFound;
